<kodit-table
  [tableConfig]="tableConfig"
  [paginatedData]="paginatedData"
  [chipItems]="cihpItems"
>
</kodit-table>
